import {
  usePublicOffersForPlacementPartnerLinksQuery,
  usePublicOffersForPlacementQuery,
} from '@graphql/react-apollo'
import { isDeal } from '@ui/lib/offer'

export const usePartnerOffersPlacement = (
  placementId: string,
  userId?: string,
) => {
  const { data, loading, error } = usePublicOffersForPlacementQuery({
    variables: {
      placementId,
      userId,
    },
    onError: (error) => {
      console.error('PartnerOffersPlacement fetch failed:', error)
    },
  })

  return {
    offers: data?.publicOffersForPlacement?.nodes?.filter(isDeal) ?? [],
    loading,
    error,
  }
}

export const usePartnerOffersPlacementPartnerLinks = (
  placementId: string,
  userId?: string,
) => {
  const { data, loading, error } = usePublicOffersForPlacementPartnerLinksQuery(
    {
      variables: {
        placementId,
        userId,
      },
      onError: (error) => {
        console.error('PartnerOffersPlacement fetch failed:', error)
      },
    },
  )

  return {
    offers: data?.publicOffersForPlacement?.nodes?.filter(isDeal) ?? [],
    loading,
    error,
  }
}
